import { render, staticRenderFns } from "./stockreport.vue?vue&type=template&id=1d043c68&scoped=true&"
import script from "./stockreport.vue?vue&type=script&lang=js&"
export * from "./stockreport.vue?vue&type=script&lang=js&"
import style0 from "./stockreport.vue?vue&type=style&index=0&id=1d043c68&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d043c68",
  null
  
)

export default component.exports